import React, {useState, setState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Carousel from 'nuka-carousel';
import { FaAngleRight, FaAngleLeft }from "react-icons/fa";
import { MdClose }from "react-icons/md";
import './OfferDescription.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const OfferDescription = (props) => {

	return(
		<section className={props.visibilityDescription + ' offer-description'}>
		<Row>
			<Col md="6">
			<h3 className="product-title">{props.title}</h3>
				<p dangerouslySetInnerHTML={{__html: props.description}}></p>
				<span className="d-block bold">{props.subTitleOne}</span>
				<div dangerouslySetInnerHTML={{__html: props.subDescriptionOne}}>
					
				</div>
				<span className="d-block bold">{props.subTitleTwo}</span>
				<div dangerouslySetInnerHTML={{__html: props.subDescriptionTwo}}>
					
				</div>
			</Col>
			<Col md="6" className="photos-box">
				{
					props.photo2 != null ? 
					(
						<Carousel className="photos"
					         autoplay="true"
					         wrapAround="true"
					         pauseOnHover="false"
					         renderCenterLeftControls={({ previousSlide }) => (
					            <button onClick={previousSlide}>
					              <FaAngleLeft />
					            </button>
					          )}
					          renderCenterRightControls={({ nextSlide }) => (
					            <button onClick={nextSlide}>
					              <FaAngleRight />
					            </button>
					         )}
					        >

					         <img src={props.photo1} alt="" />
					         <img src={props.photo2} alt="" />
					         <img src={props.photo3} alt="" />
					         <img src={props.photo4} alt="" />
					       </Carousel>) : 
					(<img src={props.photo1} alt="" className="single-photo" />)
				}
				
			</Col>
		</Row>
		<Row>
			<Col>
				<img src={props.photopp1} alt="" className="photopp" />
			</Col>
			<Col>
				<img src={props.photopp2} alt="" className="photopp" />
			</Col>
			<Col>
				<img src={props.photopp3} alt="" className="photopp" />
			</Col>
			<Col>
				<img src={props.photopp4} alt="" className="photopp" />
			</Col>
			<Col>
				<img src={props.photopp5} alt="" className="photopp" />
			</Col>
		</Row>
		<MdClose 
			className="close-description"
			size="2em"
			onClick={() => props.setvisibilityDescription('description-hidden')}
		/>
	</section>
)};

export default OfferDescription;



